module.exports = __webpack_public_path__ + "static/magazine-cover-6417624c2e8cd8b9849a4afaa7b0e75c.jpg";